import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_AppHeaderDesktop = _resolveComponent("AppHeaderDesktop")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppBottomNavigation = _resolveComponent("AppBottomNavigation")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_AppCompleteRegisterCard = _resolveComponent("AppCompleteRegisterCard")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_AppDrawer = _resolveComponent("AppDrawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, {
      id: "app",
      direction: "vertical"
    }, {
      default: _withCtx(() => [
        ($setup.getValidEvent && ($setup.type === 'sm' || $setup.type === 'md'))
          ? (_openBlock(), _createBlock(_component_AppHeader, { key: 0 }))
          : _createCommentVNode("", true),
        ($setup.getValidEvent && $setup.type === 'lg')
          ? (_openBlock(), _createBlock(_component_AppHeaderDesktop, { key: 1 }))
          : _createCommentVNode("", true),
        _createElementVNode("main", {
          class: _normalizeClass({ 'fixing-header': !$setup.isHomeView })
        }, [
          _createVNode(_component_router_view)
        ], 2),
        ($setup.isLogged)
          ? (_openBlock(), _createBlock(_component_AppBottomNavigation, { key: 2 }))
          : _createCommentVNode("", true),
        ($setup.getValidEvent)
          ? (_openBlock(), _createBlock(_component_AppFooter, {
              key: 3,
              class: "fixing-footer"
            }))
          : _createCommentVNode("", true),
        ($setup.activateCardRegister)
          ? (_openBlock(), _createBlock(_component_AppCompleteRegisterCard, { key: 4 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    ($setup.getValidEvent)
      ? (_openBlock(), _createBlock(_component_AppDrawer, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}